import comp from "./AIGradingPromptBox.js";
export default comp;
